import { NavLink } from "react-router-dom";
import { useLogout, useUserName } from "states/auth/hooks";
import styles from "./index.module.scss";

const Navbar = () => {
  const user = useUserName();
  const logout = useLogout();

  const className = ({ isActive }: { isActive: boolean }) =>
    isActive ? styles["active-link"] : styles.link;

  return (
    <header className={styles.header}>
      <div>
        <img className={styles.logo} src="/logo192.png" alt="logo" />
      </div>
      <nav className={styles.nav}>
        <NavLink className={className} to="/companies">
          公司
        </NavLink>
        <NavLink className={className} to="/jobs">
          招聘职位
        </NavLink>
        <NavLink className={className} to="/figures">
          创业园
        </NavLink>
        <NavLink className={className} to="/articles">
          活动资讯
        </NavLink>
        <NavLink className={className} to="/enrollments">
          会议报名统计
        </NavLink>
        <NavLink className={className} to="/events">
          访问统计
        </NavLink>
      </nav>
      <div className={styles.member}>
        <span>欢迎您, {user}</span>
        <button className={styles.logout} onClick={logout}>
          退出
        </button>
      </div>
    </header>
  );
};

export default Navbar;
